export default "__VITE_ASSET__Bcqa0XVT__"